module.exports = __webpack_public_path__ + "img/5.dfc6bbcb.png";